import React from 'react';
import { eventKeyConstants } from '../../../utils/eventKey'
import * as OkrPopAction from '../../actions/okr_popup.action';
import { imgUrl } from '../../../utils/url';
import { krdetailActions } from "../../../actions/krDetails.actions";
import { ClosedStatusChip } from '@workboard/ui-okr';
import { metricdetailConstants } from '../../constants/okrPopUp.constants';
import { useTranslation } from 'react-i18next';

const MetricList = ({ goalData, dispatch }: any) => {
    const { t } = useTranslation();
    const selectedMetrc = (metrcId) => {
        dispatch(OkrPopAction.UpdateSelectedMetric({ metricId: metrcId }));
        dispatch(krdetailActions.getDataSource(metrcId));
    }
    const metrics = (goalData && goalData.goalPopUpMetric) || [];
    const selectedKR = goalData && (goalData.selectedMetricId || goalData.selectedMetric);
    const showClosedLook = !!window.wbConfig?.isCloseKeyResultEnabled;
    const closedMetricIdMap = new Map(
        metrics.map((m) => [
            m.id,
            showClosedLook && Number(m.status) === metricdetailConstants.METRIC_CLOSED,
        ]),
    );

    const displayTarget = (metricObj) => {
        return (
            <div className="metric-achieve" data-testId = "metric-achieve" >
            <div className="wb-goal-achieve-text truncateText" data-testid="wb-goal-achieve-text" style={{ color: metricObj.metric_progress_color }}>
                {metricObj.achieveTarget}
            </div>
            {metricObj.targetDisplay && (
                <div className="wb-goal-target-text" data-testid="wb-goal-target-text">
                {t('of')} {metricObj.totalTarget}
                </div>
            )}
            </div>
        );
    };

    return (
        <div className="metricList">
            <ul
                className="goal-table wb-metric-table"
                aria-label={t("Activating key results in the list will update the data graph below.")}
            >
                {metrics && metrics.map((m: any) =>
                    <li
                        role="option"
                        aria-selected={m.id == selectedKR}
                        className={`goal-table-row ${m.id == selectedKR ? 'active' : ''}`}
                        data-id="charts"
                        data-metric-id={m.id}
                        key={m.id}
                        tabIndex={0}
                        onClick={() => selectedMetrc(m.id)}
                        onKeyDown={(e) => {
                            if (e.key === eventKeyConstants.ENTER || e.key === eventKeyConstants.SPACE) {
                                e.preventDefault();
                                selectedMetrc(m.id)
                            }
                        }}
                    >
                     
                          <div className="goal-table-col">{displayTarget(m)}</div>
                        <div className="goal-table-col metric-name-section">
                            <div className="metric-name">
                                {m.name}
                                {closedMetricIdMap.get(m.id) && <ClosedStatusChip />}
                                {m.progress_consider == 0
                                    && (
                                        <div className="metric-exclude-head">
                                            <img
                                                alt=""
                                                className="excludeMetric"
                                                title={t("Excluded metric")}
                                                src={imgUrl('/images/goal/exclude_metric.png')}
                                            />
                                            <span className="excludeMetricSpa">{t('Excluded from OKR progress')}</span>
                                        </div>
                                    )}
                                {goalData.goalkrWeight && goalData.goalkrMultiperAlter && m.weightage_display
                                    && (
                                        <div className="metricWeight">
                                            <span className="metricWeightSpa">W: {m.weightage_display}</span>
                                        </div>
                                    )}
                            </div>
                        </div>
                    </li>)}
            </ul>
        </div>
    )
}

export default React.memo(MetricList);
